import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const UploadIcon = (props: IconProps) => (
  <svg {...base} {...props}><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5"/><path d="M5 14v4.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V14"/></svg>
);
export const ReplayIcon = (props: IconProps) => (
  <svg {...base} {...props}><path d="M4.8 7.8A8 8 0 1 1 4 14"/><path d="M4.8 3.8v4h4"/></svg>
);
export const ExportIcon = (props: IconProps) => (
  <svg {...base} {...props}><path d="M12 3v12m0 0 4.5-4.5M12 15l-4.5-4.5"/><path d="M5 19h14"/></svg>
);
export const ChevronLeftIcon = (props: IconProps) => (
  <svg {...base} {...props}><path d="m15 18-6-6 6-6"/></svg>
);
export const ChevronUpIcon = (props: IconProps) => (
  <svg {...base} {...props}><path d="m6 15 6-6 6 6"/></svg>
);
export const CloseIcon = (props: IconProps) => (
  <svg {...base} {...props}><path d="m6 6 12 12M18 6 6 18"/></svg>
);
export const LockIcon = (props: IconProps) => (
  <svg {...base} {...props}><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
);
export const GitHubIcon = (props: IconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 16 16"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8" />
  </svg>
);
